import React, { useState } from 'react';
import {
  CheckCircle2,
  ArrowRight,
  Info,
  Calendar,
  Bell,
  Shield
} from 'lucide-react';
import { Button } from "@/components/ui/button";

const FindingItem = ({ hallazgo }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="bg-white border rounded-lg shadow-sm mb-4 overflow-hidden border-l-[6px] border-l-yellow-500">
      {/* Header */}
      <div className="bg-orange-50/50 p-4">
        <div className="flex items-start">
          <h3 className="text-base font-semibold text-gray-800">{hallazgo.hallazgo}</h3>
        </div>
      </div>

      {/* Content */}
      <div className="border-t border-gray-100">
        <div className="flex flex-col md:flex-row">
          {/* First Column: Recomendaciones */}
          {hallazgo.recomendaciones?.length > 0 && (
            <div className="md:w-1/3 p-4 border-r border-gray-100">
              <div className="flex items-center gap-2 mb-3">
                <div className="h-6 w-6 rounded-full bg-green-100 flex items-center justify-center">
                  <CheckCircle2 className="h-4 w-4 text-green-600" />
                </div>
                <h4 className="font-medium text-gray-900">Recomendaciones</h4>
              </div>

              <ul className="space-y-3.5 pl-2">
                {hallazgo.recomendaciones.map((rec, i) => (
                  <li key={i} className="flex items-start gap-2.5">
                    <div className="w-3 h-3 rounded-full bg-green-400 mt-1.5 flex-shrink-0"></div>
                    <span className="text-gray-700">{rec}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Second Column: Pasos a seguir */}
          {hallazgo.oportunidadesMejora?.length > 0 && (
            <div className="md:w-1/3 p-4 border-r border-gray-100 bg-blue-50/20">
              <div className="flex items-center gap-2 mb-3">
                <div className="h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center">
                  <ArrowRight className="h-4 w-4 text-blue-600" />
                </div>
                <h4 className="font-medium text-gray-900">Pasos a seguir</h4>
              </div>

              <ul className="space-y-3.5 pl-2">
                {hallazgo.oportunidadesMejora.map((paso, i) => {
                  // Check if the string contains bullet points
                  if (paso.includes('•')) {
                    // Split the text by bullet points
                    const [title, ...bulletPoints] = paso.split('•').map(item => item.trim());

                    return (
                      <li key={i} className="space-y-3">
                        {/* Main title */}
                        <div className="flex items-start gap-2.5">
                          <ArrowRight className="h-3.5 w-3.5 text-blue-500 mt-1 flex-shrink-0" />
                          <span className="text-gray-800 font-medium">{title}</span>
                        </div>

                        {/* Bullet points */}
                        <ul className="space-y-2.5 ml-6">
                          {bulletPoints.filter(point => point.length > 0).map((point, j) => (
                            <li key={j} className="flex items-start gap-2">
                              <div className="w-2 h-2 rounded-full bg-blue-400 mt-1.5 flex-shrink-0"></div>
                              <span className="text-gray-700">{point}</span>
                            </li>
                          ))}
                        </ul>
                      </li>
                    );
                  } else {
                    // Regular non-bulleted item
                    return (
                      <li key={i} className="flex items-start gap-2.5">
                        <ArrowRight className="h-3.5 w-3.5 text-blue-500 mt-1 flex-shrink-0" />
                        <span className="text-gray-700">{paso}</span>
                      </li>
                    );
                  }
                })}
              </ul>
            </div>
          )}

          {/* Third Column: Evolución esperada */}
          {hallazgo.pronostico && (
            <div className="md:w-1/3 p-4 bg-gray-50/40">
              <div className="flex items-center gap-2 mb-3">
                <div className="h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center">
                  <Info className="h-4 w-4 text-gray-600" />
                </div>
                <h4 className="font-medium text-gray-900">Evolución esperada</h4>
              </div>

              <div className="p-2 leading-relaxed text-gray-700">
                {hallazgo.pronostico}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const RelevantFindings = ({ hallazgosRelevantes = [] }) => {
  if (!hallazgosRelevantes?.length) return null;

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="h-6 w-6 rounded-full bg-orange-100 flex items-center justify-center">
            <Shield className="h-4 w-4 text-orange-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-gray-800">
              Aspectos a considerar
            </h2>
            <p className="text-sm text-gray-600">
              {hallazgosRelevantes.length} {hallazgosRelevantes.length === 1 ? 'aspecto' : 'aspectos'} para el bienestar de tu mascota
            </p>
          </div>
        </div>
      </div>

      {/* Findings */}
      {hallazgosRelevantes.map((hallazgo, index) => (
        <FindingItem key={index} hallazgo={hallazgo} />
      ))}
    </div>
  );
};

export default RelevantFindings;